<template>
  <div class="config-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="config-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-left="onClickLeft">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">参数设置</span>
            </div>
          </template>
        </van-nav-bar>

        <div class="content-area">

          <div class="config-card">
            <div class="config-card-header">
              <div class="header-dot"></div>
              <span>补水设置</span>
              <button class="save-btn" @click="send_config_replenish">保存参数</button>
            </div>
            <div class="config-card-body">
              <van-form label-width="50%">
                <div class="config-field">
                  <span class="config-field-label">补水间隔(小时)</span>
                  <van-stepper v-model="replenish_Interval" step="1" min="0" max="24" input-width="50px" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">补水超时(分钟)</span>
                  <van-stepper v-model="replenish_timeout" step="1" min="0" max="60" input-width="50px" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">补水时段(开始)</span>
                  <van-stepper v-model="replenish_time_start" step="1" min="0" max="23" input-width="50px" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">补水时段(结束)</span>
                  <van-stepper v-model="replenish_time_stop" step="1" min="0" max="23" input-width="50px" />
                </div>
              </van-form>
            </div>
          </div>

          <div class="config-card">
            <div class="config-card-header">
              <div class="header-dot"></div>
              <span>系统设置</span>
              <button class="save-btn" @click="send_config_sys">保存参数</button>
            </div>
            <div class="config-card-body">
              <van-form label-width="50%">
                <div class="config-field">
                  <span class="config-field-label">暂停时间(分钟)</span>
                  <van-stepper v-model="pause_time" step="1" min="1" max="60" input-width="50px" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">无水检测</span>
                  <van-switch v-model="no_water" size="20" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">告警音</span>
                  <van-switch v-model="alarm_beep" size="20" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">温度告警</span>
                  <van-switch v-model="alarm_t" size="20" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">低温告警(℃)</span>
                  <van-stepper v-model="alarm_tl" step="1" min="0" max="99" input-width="50px" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">高温告警(℃)</span>
                  <van-stepper v-model="alarm_th" step="1" min="0" max="99" input-width="50px" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">温度校准(℃)</span>
                  <van-stepper v-model="alarm_jz" step="0.1" min="-10" max="10" input-width="50px" />
                </div>
              </van-form>
            </div>
          </div>

        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: "KD1Config",
  data() {
    return {
      devdata: null,
      did: this.$route.query.did,
      replenish_Interval: 0,
      replenish_timeout: 0,
      replenish_temp: 0,
      replenish_time_start: 0,
      replenish_time_stop: 0,

      pause_time: 0,
      no_water: 0,
      alarm_beep: 1,
      lcd_off_time: 1,

      alarm_t: 0,
      alarm_tl: 1,
      alarm_th: 1,
      alarm_jz: 0,
    };
  },
  mounted() {
    this.GetDevData(this.did);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.devdata = response.data;
            this.pause_time = this.devdata.config.pt
            this.replenish_Interval = this.devdata.config.red[1]
            this.replenish_timeout = this.devdata.config.red[2]
            this.replenish_temp = this.devdata.config.red[3]
            this.replenish_time_start = this.devdata.config.red[4]
            this.replenish_time_stop = this.devdata.config.red[5]

            this.pause_time = this.devdata.config.sysd[0]
            this.no_water = this.devdata.config.sysd[1] == 1 ? true : false
            this.alarm_beep = this.devdata.config.sysd[2] == 1 ? true : false
            this.lcd_off_time = this.devdata.config.sysd[3]

            this.alarm_t = this.devdata.config.alm[0] == 1 ? true : false
            this.alarm_tl = this.devdata.config.alm[1]
            this.alarm_th = this.devdata.config.alm[2]
            this.alarm_jz = this.devdata.config.alm[3] / 10.0

          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    send_config(data) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did,
          d_type: "KD-1",
          config: JSON.stringify(data),
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$notify({ type: "success", message: "设置成功！" });
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$notify({ type: "danger", message: "设置失败！" });
          }
          this.GetDevData(this.did);
        })
        .catch((error) => {
          this.GetDevData(this.did);
          this.$notify({ type: "danger", message: "设置失败！" });
        });
    },
    send_config_replenish() {
      var buf = {
        re_Interval: this.replenish_Interval,
        re_timeout: this.replenish_timeout,
        re_temp: this.replenish_temp,
        re_time_start: this.replenish_time_start,
        re_time_stop: this.replenish_time_stop
      };
      this.send_config(buf);
    },
    send_config_sys() {
      var buf = {
        pause_time: this.pause_time,
        no_water: this.no_water == true ? 1 : 0,
        alarm_beep: this.alarm_beep == true ? 1 : 0,
        lcd_off_time: this.lcd_off_time,
        alarm_t: this.alarm_t == true ? 1 : 0,
        alarm_tl: this.alarm_tl,
        alarm_th: this.alarm_th,
        alarm_jz: this.alarm_jz * 10
      };
      this.send_config(buf);
    },
    onReflash() { this.devrefresh(); },
    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KD-1",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          }
        })
        .catch((error) => { this.isLoading = false; });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}
</style>

<style scoped>
.config-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.config-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.config-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.config-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.header-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2dd4bf;
  flex-shrink: 0;
}

.config-card-header span {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.save-btn {
  height: 30px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
  box-shadow: 0 2px 8px rgba(45, 212, 191, 0.25);
  transition: transform 0.15s;
  flex-shrink: 0;
}

.save-btn:active { transform: scale(0.95); }

.config-card-body {
  padding: 4px 0;
}

.config-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  min-height: 40px;
}

.config-field-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.config-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

:deep(.van-stepper__input) {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #1e293b;
  font-size: 14px;
  font-weight: 500;
}

:deep(.van-stepper__minus),
:deep(.van-stepper__plus) {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}
</style>
